<template>
    <div class="contentHome">
        <div class="centerPage">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
                <el-breadcrumb-item :to="{ path: '/examDetail' ,query:{back:back,id: id}}">心理测试详情</el-breadcrumb-item>
                <el-breadcrumb-item>测试问题</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="question">
                <h3>{{detail.title}}</h3>
                <div class="questionList" v-loading="loading">
                    <div class="questionLi">
                        <p class="tit">{{question.title}}</p>
                        <span class="count">第{{question.index}}题，共{{detail.subjectCount}}题</span>
                        <template v-if="question.subjectType==1 || question.subjectType==2">
                            <el-radio-group v-model="answer.answerRadio" class="radioGroup">
                                <el-radio :label="item.id+''" v-for="(item,index) in question.options" :key="index">
                                    {{item.title}}
                                </el-radio>
                            </el-radio-group>
                        </template>
                        <template v-if="question.subjectType==3">
                            <el-checkbox-group v-model="answer.answerChecked"  class="radioGroup">
                                <el-checkbox :label="item.id+''" v-for="(item,index) in question.options" :key="index">
                                    {{item.title}}
                                </el-checkbox>
                            </el-checkbox-group>
                        </template>
                        <template  v-if="question.subjectType==4 || question.subjectType==5">
<!--                            <div style="text-align: left; margin: 10px 0; color: #666;">回答：</div>-->
                            <el-input type="textarea"  :autosize="{ minRows: 5, maxRows: 10}" class="textA" v-model="answer.answerContent" placeholder="请输入..."></el-input>
                        </template>
                    </div>
                    <div class="sub">
                        <el-button @click="prevQuestion()" v-if="question.index!==1">上一题</el-button>
                        <el-button @click="nextQuestion()" v-if="question.index!==detail.subjectCount">下一题</el-button>
                        <el-button class="submitBtn" @click="submitBtn" v-if="question.index===detail.subjectCount">提交
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                class="tips paySuccess"
                top="0"
                :visible.sync="dialogVisible"
                width="400px">
            <img src="../../assets/img/success.png" alt="" width="140">
            <p>
                提交成功！<br/>
                <span v-if="resultType==2">医生分析之后出测试结果</span>
            </p>
            <div class="sub">
                <el-button @click="showResultDetails">{{resultType==1?'查看结果':'我知道了'}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import base from '@/api/common';
    import qs from "qs";
    export default {
        name: "examQuestion",
        data() {
            return {
                detail: {},
                dialogVisible: false,
                back: this.$route.query.back,
                id: this.$route.query.id,
                resultId: 0,
                resultNo: '',
                resultType: 1,
                loading: false,
                question:{
                    title: '',
                    index: 1,
                    options:[
                        {id:1,title:'option'},
                    ],
                },
                answer:{
                    answerRadio: '0',
                    answerChecked: [],
                    answerContent:'',
                }

            }
        },
        mounted() {
            // 测试内容
            this.$ajax.get(base.api.exam.examResult.replace("{id}",this.id)).then((res)=>{
                if(res.data.status === 'success'){
                    this.detail = res.data.data;
                    // 加载第一道题目
                    if(res.data.data && res.data.data.result){
                        this.resultId = res.data.data.result.id;
                        this.resultNo = res.data.data.result.resultNo;
                        this.resultType = res.data.data.result.resultType;
                        this.getQuestion(1);
                    }
                }
            });
        },
        methods: {
            submitBtn() {
                // 提交  回答最后一道题
                let answer;
                if(this.question.subjectType == 1 || this.question.subjectType == 2){ //单、判
                    answer = this.answer.answerRadio;
                }else if(this.question.subjectType == 3){ //多
                    answer = this.answer.answerChecked.join(",");
                }else{ //填、答
                    answer = this.answer.answerContent;
                }
                if(!answer){
                    this.$message.warning("当前题目还没有作答");
                    return;
                }
                this.loading = true;
                this.$ajax.post(base.api.exam.subject.doAnswer.replace("{id}",this.question.id).replace("{no}",this.resultNo),qs.stringify({
                    answer: answer
                })).then((res)=>{
                    if(res.data.status === 'success'){
                        // 最后一道题回答完成, 提交
                        this.$ajax.post(base.api.exam.submit.replace("{no}",this.resultNo)).then((submitRes)=>{
                            this.loading = false;
                            if(submitRes.data.status === 'success'){
                                this.dialogVisible = true;
                            }else{
                                this.$message.error(submitRes.data.message);
                            }
                        }).catch((err) => {
                          console.error(err);
                          this.$message.error('操作失败');
                        });
                    }else{
                        this.loading = false; // 答题发生错误才消失
                        this.$message.error(res.data.message);
                    }
                });

            },
            showResultDetails(){
                this.$router.push({name: 'psyDetail',query:{back:this.back, id: this.id, no: this.resultNo}});
            },
            nextQuestion() {

                let answer;
                if(this.question.subjectType == 1 || this.question.subjectType == 2){ //单、判
                    answer = this.answer.answerRadio;
                }else if(this.question.subjectType == 3){ //多
                    answer = this.answer.answerChecked.join(",");
                }else{ //填、答
                    answer = this.answer.answerContent;
                }
                if(!answer){
                    this.$message.warning("当前题目还没有作答");
                    return;
                }
                this.loading = true;
                this.$ajax.post(base.api.exam.subject.doAnswer.replace("{id}",this.question.id).replace("{no}",this.resultNo),qs.stringify({
                    answer: answer
                })).then((res)=>{
                    this.loading = false;
                    if(res.data.status === 'success'){
                        this.getQuestion(this.question.index+1);
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            },
            prevQuestion() {
                this.loading = true;
                let index = this.question.index-1<1 ? 1 : (this.question.index-1);
                this.getQuestion(index);
                this.loading = false;
            },
            getQuestion(index){
                this.$ajax.get(base.api.exam.subject.question.replace("{no}",this.resultNo),{params:{index: index}}).then((res)=>{
                    if(res.data.status === 'success'){
                        this.question = res.data.data;
                        // 获取作答情况
                        if(res.data.data){
                            this.$nextTick(this.getResultOptions(res.data.data.id));
                        }
                    }
                })
            },
            getResultOptions(subjectId){
                // 先清理上次作答的选项
                this.answer.answerRadio = '';
                this.answer.answerChecked = [];
                this.answer.answerContent = '';

                this.$ajax.get(base.api.exam.subject.answer.replace("{id}",this.resultId),{params:{sid: subjectId}}).then((res)=>{
                    if(res.data.status === 'success' && res.data.data){
                        switch (this.question.subjectType) {
                            case 1: //单
                            case 2: //判
                                this.answer.answerRadio = res.data.data.answers + '';
                                break;
                            case 3: //多
                                this.answer.answerChecked = res.data.data.answers.split(",").map(String);
                                break;
                            case 4: //填
                            case 5: //问
                                this.answer.answerContent = res.data.data.answers;
                                break;
                        }
                        // console.log(this.answer)
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/css/psychological.scss";
</style>